import { FC, useMemo } from 'react'
import { Col } from 'react-bootstrap'

import { resolveProgressBars } from 'components/monitoring/utils'
import Loader from 'components/ui/loader/Loader'
import { AreaProgress as IAreaProgress, CourseProgress } from 'graphqlAPI'
import { useTranslationRankmi } from 'helpers/translations.helper'

import { prefix } from '../Tabs/Areas/constants'
import { Cards } from './Cards'

interface GeneralProgressProps {
  data?: {
    coursesProgress?: IAreaProgress[]
    participantsAdvance?: CourseProgress
    coursesAdvance?: CourseProgress
    participantsCount: number
    coursesCount: number
  }
  loading: boolean
}

export const GeneralProgress: FC<GeneralProgressProps> = ({
  data,
  loading,
}) => {
  const { coursesProgress, participantsAdvance, coursesAdvance } = { ...data }

  const { participants, courses } = useMemo(
    () =>
      resolveProgressBars({
        coursesProgress,
        participantsAdvance,
        coursesAdvance,
      }),
    [coursesProgress, participantsAdvance, coursesAdvance]
  )
  const tRelative = useTranslationRankmi({ prefix })

  if (loading) {
    return (
      <Col>
        <div className="d-flex justify-content-center">
          <Loader color />
        </div>
      </Col>
    )
  }
  if (!data) return null

  const { coursesCount, participantsCount } = data

  return (
    <>
      <Col md={12} lg={6}>
        <Cards
          title={tRelative('cards.courses')}
          total={coursesCount}
          className="mt-6"
          finish={courses.finish}
          inProgress={courses.inProgress}
          pending={courses.pending}
        />
      </Col>
      <Col md={12} lg={6}>
        <Cards
          title={tRelative('cards.participants')}
          total={participantsCount}
          className="mt-6"
          finish={participants.finish}
          inProgress={participants.inProgress}
          pending={participants.pending}
        />
      </Col>
    </>
  )
}
